export default __webpack_public_path__ + "static/media/Neighbour_Army.7da3f553.webp";